/**
 * Branded identifiers. They are plain strings at runtime but the brand prevents
 * accidentally passing an ObjectId where a WorkspaceId is expected.
 */
declare const brand: unique symbol;

type Brand<T, Name extends string> = T & { readonly [brand]: Name };

export type ObjectId = Brand<string, 'ObjectId'>;
export type WorkspaceId = Brand<string, 'WorkspaceId'>;
export type ConnectionId = Brand<string, 'ConnectionId'>;
export type ApplicationId = Brand<string, 'ApplicationId'>;
export type CommandId = Brand<string, 'CommandId'>;
export type BookmarkId = Brand<string, 'BookmarkId'>;

export const asObjectId = (value: string): ObjectId => value as ObjectId;
export const asWorkspaceId = (value: string): WorkspaceId => value as WorkspaceId;
export const asConnectionId = (value: string): ConnectionId => value as ConnectionId;
export const asApplicationId = (value: string): ApplicationId => value as ApplicationId;
export const asCommandId = (value: string): CommandId => value as CommandId;
export const asBookmarkId = (value: string): BookmarkId => value as BookmarkId;
